module.exports = __webpack_public_path__ + "586a49b615c4813c3eac50e66256106c.svg";